import { CircularProgress, SxProps, Theme } from "@mui/material";
import MDBox from "mdComponents/MDBox";
import MDTypography from "mdComponents/MDTypography";

interface LoadingSpinnerProps {
  title?: string;
  size?: number;
  color?: "inherit" | "info" | "primary" | "secondary" | "error" | "success" | "warning";
  style?: SxProps<Theme>;
  fontVariant?: string;
}

const LoadingSpinner = ({
  title,
  size = 20,
  color = "info",
  style,
  fontVariant,
}: LoadingSpinnerProps) => {
  const fontSize = Math.max(12, size * 0.6); // keep readable at small sizes

  return (
    <MDBox
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center", // 👈 vertical alignment
        gap: 1,
        my: 2,
      }}
    >
      <CircularProgress
        color={color}
        size={size}
        sx={style}
      />

      {title && (
        <MDTypography
          variant={fontVariant ?? "h6"}
          sx={{
            fontSize, // 👈 scale with spinner
            lineHeight: 1,
          }}
        >
          {title}...
        </MDTypography>
      )}
    </MDBox>
  );
};

export default LoadingSpinner;
